import type React from 'react';

import { tabsRoot } from '@mage-ui/styled-system/recipes';
import { Tabs as MantineTabs } from '@mantine/core';

import { TabsList } from './TabsList';
import { TabsPanel } from './TabsPanel';
import { TabsTab } from './TabsTab';

export type TabsProps = {
  classNames?: {
    root?: string;
  };
  children?: React.ReactNode;
  defaultValue?: string;
  value?: string;
};

export const Tabs = ({ classNames, children, ...props }: TabsProps) => {
  return (
    <MantineTabs
      classNames={{
        root: classNames?.root ?? tabsRoot(),
      }}
      {...props}
    >
      {children}
    </MantineTabs>
  );
};

Tabs.displayName = 'Tabs';

Tabs.List = TabsList;
Tabs.Tab = TabsTab;
Tabs.Panel = TabsPanel;
